import { injectable, inject } from 'inversify';
import Debug from 'debug';
import { QuizSessionServiceSymbol, QuizSessionService } from '@/app/quiz-session/service';
import { StartExamSessionCommand, UpdateExamSessionQuestionStateCommand, UpdateExamSessionNavigationCommand,
         StartExamSessionCommandPayload, UpdateExamSessionQuestionStateCommandPayload,
         UpdateExamSessionNavigationCommandPayload, UpdateExamSessionQuestionTimesCommand,
         UpdateExamSessionQuestionTimesCommandPayload } from '../domain';

const debug = Debug('exam-session-service')

export const ExamSessionServiceSymbol = Symbol.for('ExamSessionService')

@injectable()
export class ExamSessionService {

  constructor(
    @inject(QuizSessionServiceSymbol)
    private quizSessionService: QuizSessionService) {
  }
  
  startSession(sessionId: string, examId: string, aspect: string, details: StartExamSessionCommandPayload) {

    debug('start-session', sessionId, examId, details)

    const command: StartExamSessionCommand = {
      name: 'start-exam-session',
      payload: {
        questionIds: details.questionIds,
        startTime: details.startTime,
        questionIndex: details.questionIndex
      }
    }
    
    this.quizSessionService.startSession<StartExamSessionCommand>(sessionId, examId, aspect, 'exam', command)
  }

  updateQuestionState(sessionId: string, details: UpdateExamSessionQuestionStateCommandPayload) {
    debug('update-question-state', sessionId, details)

    const command: UpdateExamSessionQuestionStateCommand = {
      name: 'update-exam-session-question-state',
      payload: details
    }
    
    this.quizSessionService.updateSession<UpdateExamSessionQuestionStateCommand>(sessionId, command)
  }

  updateNavigation(sessionId: string, details: UpdateExamSessionNavigationCommandPayload) {
    debug('update-navigation', sessionId, details)

    const command: UpdateExamSessionNavigationCommand = {
      name: 'update-exam-session-navigation',
      payload: details
    }

    this.quizSessionService.updateSession<UpdateExamSessionNavigationCommand>(sessionId, command)
  }

  updateQuestionTimes(sessionId: string, details: UpdateExamSessionQuestionTimesCommandPayload) {
    debug('update-question-times', sessionId, details)

    const command: UpdateExamSessionQuestionTimesCommand = {
      name: 'update-exam-session-question-times',
      payload: details
    }

    this.quizSessionService.updateSession<UpdateExamSessionQuestionTimesCommand>(sessionId, command)
  }

  finishSession(sessionId: string) {
    debug('finish-session', sessionId)

    this.quizSessionService.finishSession(sessionId)
  }

  abortSession(sessionId: string) {
    debug('abort-session', sessionId)

    this.quizSessionService.abortSession(sessionId)
  }
}
